import _tslib from "tslib";
import { dew as _PDFAcroButtonDew } from "./PDFAcroButton";
import { dew as _PDFAcroCheckBoxDew } from "./PDFAcroCheckBox";
import { dew as _PDFAcroChoiceDew } from "./PDFAcroChoice";
import { dew as _PDFAcroComboBoxDew } from "./PDFAcroComboBox";
import { dew as _PDFAcroFieldDew } from "./PDFAcroField";
import { dew as _PDFAcroFormDew } from "./PDFAcroForm";
import { dew as _PDFAcroListBoxDew } from "./PDFAcroListBox";
import { dew as _PDFAcroNonTerminalDew } from "./PDFAcroNonTerminal";
import { dew as _PDFAcroPushButtonDew } from "./PDFAcroPushButton";
import { dew as _PDFAcroRadioButtonDew } from "./PDFAcroRadioButton";
import { dew as _PDFAcroSignatureDew } from "./PDFAcroSignature";
import { dew as _PDFAcroTerminalDew } from "./PDFAcroTerminal";
import { dew as _PDFAcroTextDew } from "./PDFAcroText";
import { dew as _flagsDew } from "./flags";
import { dew as _utilsDew } from "./utils";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var tslib_1 = _tslib;

  var PDFAcroButton_1 = _PDFAcroButtonDew();

  Object.defineProperty(exports, "PDFAcroButton", {
    enumerable: true,
    get: function () {
      return PDFAcroButton_1.default;
    }
  });

  var PDFAcroCheckBox_1 = _PDFAcroCheckBoxDew();

  Object.defineProperty(exports, "PDFAcroCheckBox", {
    enumerable: true,
    get: function () {
      return PDFAcroCheckBox_1.default;
    }
  });

  var PDFAcroChoice_1 = _PDFAcroChoiceDew();

  Object.defineProperty(exports, "PDFAcroChoice", {
    enumerable: true,
    get: function () {
      return PDFAcroChoice_1.default;
    }
  });

  var PDFAcroComboBox_1 = _PDFAcroComboBoxDew();

  Object.defineProperty(exports, "PDFAcroComboBox", {
    enumerable: true,
    get: function () {
      return PDFAcroComboBox_1.default;
    }
  });

  var PDFAcroField_1 = _PDFAcroFieldDew();

  Object.defineProperty(exports, "PDFAcroField", {
    enumerable: true,
    get: function () {
      return PDFAcroField_1.default;
    }
  });

  var PDFAcroForm_1 = _PDFAcroFormDew();

  Object.defineProperty(exports, "PDFAcroForm", {
    enumerable: true,
    get: function () {
      return PDFAcroForm_1.default;
    }
  });

  var PDFAcroListBox_1 = _PDFAcroListBoxDew();

  Object.defineProperty(exports, "PDFAcroListBox", {
    enumerable: true,
    get: function () {
      return PDFAcroListBox_1.default;
    }
  });

  var PDFAcroNonTerminal_1 = _PDFAcroNonTerminalDew();

  Object.defineProperty(exports, "PDFAcroNonTerminal", {
    enumerable: true,
    get: function () {
      return PDFAcroNonTerminal_1.default;
    }
  });

  var PDFAcroPushButton_1 = _PDFAcroPushButtonDew();

  Object.defineProperty(exports, "PDFAcroPushButton", {
    enumerable: true,
    get: function () {
      return PDFAcroPushButton_1.default;
    }
  });

  var PDFAcroRadioButton_1 = _PDFAcroRadioButtonDew();

  Object.defineProperty(exports, "PDFAcroRadioButton", {
    enumerable: true,
    get: function () {
      return PDFAcroRadioButton_1.default;
    }
  });

  var PDFAcroSignature_1 = _PDFAcroSignatureDew();

  Object.defineProperty(exports, "PDFAcroSignature", {
    enumerable: true,
    get: function () {
      return PDFAcroSignature_1.default;
    }
  });

  var PDFAcroTerminal_1 = _PDFAcroTerminalDew();

  Object.defineProperty(exports, "PDFAcroTerminal", {
    enumerable: true,
    get: function () {
      return PDFAcroTerminal_1.default;
    }
  });

  var PDFAcroText_1 = _PDFAcroTextDew();

  Object.defineProperty(exports, "PDFAcroText", {
    enumerable: true,
    get: function () {
      return PDFAcroText_1.default;
    }
  });

  tslib_1.__exportStar(_flagsDew(), exports);

  tslib_1.__exportStar(_utilsDew(), exports); //# sourceMappingURL=index.js.map


  return exports;
}